<template>
	<div>

		<ui-box>
			<h5>Pass Invites</h5>
			<v-divider class="my-4 opacity-70"></v-divider>

			<template v-for="(inviteGroup, key) in invitesGroups">

				<div v-if="invitesGroups[key].invites.length" class="invite-group" :key="key">
					<h6 class="black--text mb-2 mt-4">
						{{ inviteGroup.title }}
						<v-badge
								color="primary"
								:content="invitesGroups[key].invites.length"
								inline
						></v-badge>
					</h6>
					<div
							v-for="(invite, idx) in inviteGroup.invites"
							:key="`invite-${invite.id}`"
							class="align-center d-flex dashboard-invite"
					>
						<v-row class="align-center w-100" no-gutters @click="viewInvite(invite)">
							<v-col class="" lg="3" md="3" xl="3">
								<v-chip v-if="!invite.active"
										class="ma-2"
										color="#fcf1e1"
										text-color="#f3b760"
								>
									Inactive
								</v-chip>
								<div
									class="font-weight-bold text-subtitle-1 text-truncate primary--text text--darken-4">
									{{ invite.name }}
								</div>
								<div class="text-caption text-truncate primary--text text--darken-2">
									{{ invite.partnerName }}
								</div>
							</v-col>
							<v-col order="last" order-sm="2" class="flex-grow-1 mt-4 mt-sm-0" cols="12"
										 sm="">
								<invite-avatars :invite="invite" :maxAvatars="10"></invite-avatars>
							</v-col>
							<v-col class="" order="2" order-sm="last" cols="auto">
								<template v-if="invite.statusCode === 'invited'">
									<v-btn
											color="accent"
											depressed
											:href="viewInvite(invite)"
											rounded
											small
									>
										<v-icon small>mdi-store-plus-outline</v-icon>
										View
									</v-btn>
								</template>
								<template v-else>
									<v-btn
											color="secondary"
											depressed
											:href="viewDetails(invite)"
											rounded
											small
									>
										<v-icon small>mdi-card-account-details-outline</v-icon>
										View
									</v-btn>
								</template>
							</v-col>
						</v-row>
					</div>
				</div>
			</template>
		</ui-box>
	</div>
</template>

<script>
import { inviteHelpers } from '../../../Shared/helpers';

export default {
	name: 'CampaignInvites',
	props: {
		invitesData: {
			type: Array,
			default: () => []
		},
		statuses: {
			type: Array,
			default: () => []
		},
		venue: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			inviteHelpers,
			invites: this.invitesData,
			panels: {
				active: null,
				declined: null,
				inProgress: null,
				invited: 0, // always show the first invite is there are any
				review: null
			}
		};
	},
	computed: {
		invitesGroups() {
			return {
				invited: {
					title: "You're Invited",
					icon: 'asdf',
					description:
							'The following campaigns have formally asked you to join their pass. Click to view all the information about this pass and other invited merchants.',
					invites: this.getInvitesByStatus(15)
				},
				inProgress: {
					title: 'Passes In Progress',
					icon: 'mdi-progress-clock',
					description: 'Put the in progress description here.',
					invites: [...this.getInvitesByStatus(16), ...this.getInvitesByStatus(22)]
				},
				review: {
					title: 'Passes In Review',
					icon: 'mdi-clock-alert-outline',
					description: 'Something must be in a review status.',
					invites: this.getInvitesByStatus(17)
				},
				active: {
					title: 'Active Passes',
					icon: 'mdi-check-decagram-outline',
					description: 'Here are all your ongoing pass invites.',
					invites: this.getInvitesByStatus(21)
				},
				declined: {
					title: 'Declined Pass Invites',
					icon: 'mdi-card-off-outline',
					description:
							"These are invitations you have previously declined. If time permits, you may 'undo' your decline and accept the invite.",
					invites: this.getInvitesByStatus(18)
				}
			};
		},
		campaignStatuses() {
			return this.statuses.filter(status => status.assignment === 'campaign_assignment');
		},
		productStatuses() {
			return this.statuses.filter(status => status.assignment === 'product');
		},
		venueStatuses() {
			return this.statuses.filter(status => status.assignment === 'venue');
		}
	},
	created() {
	},
	methods: {
		acceptInvite(invite) {
			const params = {
				status: 16,
				skipAutoAccept: true
			};
			this.axios
					.put(`/venues/${this.venue.id}/campaigns/${invite.id}`, params)
					.then(() => {
						const idx = this.invites.findIndex(inv => inv.id === invite.id);
						this.$set(this.invites, idx, {
							...this.invites[idx],
							status: 16,
							statusCode: 'in_progress',
							statusName: 'In Progress'
						});
					});
		},
		declineInvite(invite, undo = false) {
			const params = {
				status: undo ? 15 : 18,
				skipAutoAccept: true
			};
			this.axios
					.put(`/venues/${this.venue.id}/campaigns/${invite.id}`, params)
					.then(() => {
						const idx = this.invites.findIndex(inv => inv.id === invite.id);
						this.$set(this.invites, idx, {
							...this.invites[idx],
							status: params.status,
							statusCode: undo ? 'invited' : 'declined',
							statusName: undo ? 'Invited' : 'Declined'
						});
						this.$nextTick(() => {
							if(!undo)
								document.getElementById(`invited-${invite.id}`).scrollIntoView(true);
						});
					});
		},
		getInvitesByStatus(status) {
			return this.invites.filter(invite => invite.status === status);

			// return this.campaignStatuses.reduce((acc, status) => {
			//	 const campaigns = this.invites.filter(
			//		 invite => status.code === `${status.assignment}_${invite.statusCode}`
			//	 );
			//	 const inviteStatusCode = status.code.replace(`${status.assignment}_`, '');
			//	 return { ...acc, [inviteStatusCode]: campaigns };
			// }, {});
		},
		viewInvite(invite) {
			return `/merchant-portal/${this.venue.id}/invites/view/landing/${invite.id}`;
		},
		viewDetails(invite) {
			return `/merchant-portal/${this.venue.id}/invites/view/invite/${invite.id}`;
		}
	}
};
</script>

<style lang="scss" scoped>
@use 'sass:color';
@import '~vuetify/src/styles/settings/_variables';

.dashboard-invite {
	background-color: saturate(mix(white, #7a9176, 96%), 30%);
	border-radius: 0.5rem !important;
	cursor: pointer;
	margin-bottom: 0;
	min-height: 72px;
	padding: 0 1rem;
	transition: background-color 300ms ease-in-out;

	&:hover {
		background-color: saturate(mix(white, #7a9176, 88%), 30%);
	}

	& + .dashboard-invite {
		margin-top: 1rem;
	}

}

.invite-group {
	position: relative;

	& + .invite-group {
		margin-top: 1rem;
		// padding-top: 1rem;

		/*&:before {
			background-color: saturate(mix(white, #7a9176, 75%), 30%);
			content: '';
			height: 1px;
			position: absolute;
			top: 0;
			width: 100%;
		}*/
	}
}
</style>
